import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; 
import { SharedModule } from '../../shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrdersComponent } from './orders/orders.component';
import { TransactionsComponent } from './transactions/transactions.component';
import {AgGridModule} from "ag-grid-angular";
import {FiltersComponent} from "./filters/filters.component";
import {OrderSessionDialogComponent} from "./orders/order-session-dialog/order-session-dialog.component";
type PathMatch = "full" | "prefix" | undefined;
export const routes = [ 
  { path: '', redirectTo: 'orders', pathMatch: 'full' as PathMatch},
  { path: 'orders', component: OrdersComponent, data: { breadcrumb: 'Orders' } },
  { path: 'transactions', component: TransactionsComponent, data: { breadcrumb: 'Transactions' } } 
];

@NgModule({
  declarations: [
    OrderSessionDialogComponent,
    OrdersComponent,
    FiltersComponent,
    TransactionsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes), 
    SharedModule,
    AgGridModule,
    NgxPaginationModule,
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class SalesModule { }
